import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function LoginUserService(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.post(
        `${URL_AUTH}/api/admin/v1/movil/login`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          }
        }
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}
